module.exports = __webpack_public_path__ + "img/login.2f0e229b.png";